module.exports = __webpack_public_path__ + "static/media/historic_georgian_6.8f753043.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/projects/historic_georgian_6.jpg
// module id = 526
// module chunks = 0